// Cover image URLs for display. Providers store their largest cover size
// (Open Library `-L`, TMDB `w500`, IGDB `t_cover_big`); `coverSrc` swaps in
// a variant sized for where the image is shown, then routes it through the
// Cloudflare image cache (ADR 0013) when REACT_APP_IMAGE_URL is set.

export type CoverSize = "thumb" | "card" | "detail";

const OPEN_LIBRARY: Record<CoverSize, string> = {
  thumb: "S",
  card: "M",
  detail: "L",
};
const TMDB: Record<CoverSize, string> = {
  thumb: "w92",
  card: "w342",
  detail: "w500",
};
const IGDB: Record<CoverSize, string> = {
  thumb: "t_cover_small",
  card: "t_cover_big",
  detail: "t_cover_big",
};

function resize(url: URL, size: CoverSize): void {
  switch (url.hostname) {
    case "covers.openlibrary.org":
      url.pathname = url.pathname.replace(
        /-[SML]\.jpg$/,
        `-${OPEN_LIBRARY[size]}.jpg`,
      );
      break;
    case "image.tmdb.org":
      url.pathname = url.pathname.replace(
        /^\/t\/p\/[^/]+\//,
        `/t/p/${TMDB[size]}/`,
      );
      break;
    case "images.igdb.com":
      url.pathname = url.pathname.replace(
        /\/t_[a-z0-9_]+\//,
        `/${IGDB[size]}/`,
      );
      break;
  }
}

export function coverSrc(url: string, size: CoverSize): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (parsed.protocol !== "https:") return url;
  resize(parsed, size);
  const proxy = process.env.REACT_APP_IMAGE_URL;
  if (!proxy) return parsed.toString();
  return `${proxy.replace(/\/$/, "")}/${parsed.host}${parsed.pathname}${parsed.search}`;
}
